import { render, staticRenderFns } from "./ReplyModal.vue?vue&type=template&id=10749c12&"
import script from "./ReplyModal.vue?vue&type=script&lang=js&"
export * from "./ReplyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports